"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("@/app/shared/css/scheduler-dialog.css");
const config_1 = require("@/app/shared/config");
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const react_1 = require("react");
const SchedulerDialog = () => {
    const [isAuthReady, setIsAuthReady] = (0, react_1.useState)(() => !!helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_TYPE));
    const iframeRef = (0, react_1.useRef)(null);
    const authStorageRef = (0, react_1.useRef)({});
    const sendAuthToIframe = (0, react_1.useCallback)(() => {
        iframeRef.current?.contentWindow?.postMessage({ type: constants_1.RegularMessage.INIT_AUTH_STORAGE, payload: { storage: authStorageRef.current } }, config_1.Config.SUMO_ENV_EXTENSION_ORIGIN);
    }, []);
    const innerListener = (message) => {
        if (message.data?.type === constants_1.RegularMessage.IFRAME_AUTH_READY) {
            sendAuthToIframe();
            return;
        }
        if (!window.Office?.context?.ui?.messageParent)
            return;
        window.Office.context.ui.messageParent(JSON.stringify(message.data));
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('message', innerListener);
        const initOffice = () => {
            if (!window.Office?.context?.ui)
                return;
            window.Office.context.ui.addHandlerAsync(window.Office.EventType.DialogParentMessageReceived, (arg) => {
                try {
                    const data = JSON.parse(arg.message);
                    if (data.type === constants_1.RegularMessage.INIT_AUTH_STORAGE && data.payload?.storage) {
                        authStorageRef.current = data.payload.storage;
                        for (const [key, value] of Object.entries(data.payload.storage)) {
                            if (value && value !== 'undefined') {
                                helpers_1.Storage.Local.set(key, value);
                            }
                        }
                        if (data.payload.subject !== undefined) {
                            helpers_1.Storage.Local.set(helpers_1.Storage.Key.SUBJECT, data.payload.subject);
                        }
                        if (data.payload.recipientsEmails) {
                            helpers_1.Storage.Local.set(helpers_1.Storage.Key.RECIPIENTS_EMAILS, JSON.stringify(data.payload.recipientsEmails));
                        }
                        setIsAuthReady(true);
                    }
                }
                catch (e) {
                    console.error('Failed to parse parent message:', e);
                }
            });
            window.Office.context.ui.messageParent(JSON.stringify({ type: constants_1.RegularMessage.DIALOG_AUTH_READY }));
        };
        if (window.Office?.onReady) {
            window.Office.onReady(initOffice);
        }
        else {
            initOffice();
        }
        return () => {
            window.removeEventListener('message', innerListener);
        };
    }, []);
    if (!isAuthReady)
        return null;
    return ((0, jsx_runtime_1.jsx)("iframe", { ref: iframeRef, className: 'scheduler-dialog-iframe', src: helpers_1.query.set(config_1.Config.SUMO_ENV_EXTENSION_ORIGIN, {
            integration: "MICROSOFT" /* Integration.MICROSOFT */,
            extensionIntegration: constants_1.ExtensionIntegration.OUTLOOK,
        }) }));
};
exports.SchedulerDialog = SchedulerDialog;
